import api from './api';

export const loginUser = async (email: string, password: string) => {
  try {
    const response = await api.post('/auth/login', {
      email,
      password,
    });
    console.log("response from login", response)

    return response.data;
    
  } catch (err: any) {

    // Forward the API error message
    throw err.response?.data?.message || "Login failed";
  }
};

export const registerAdmin = async (data: {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  phone_number: string;
  responsibility: string;
  role: string;
  year_of_employment: string;
}) => {
  const response = await api.post("/auth/register", data);
  console.log("response from signup", response)
  return response.data;
};
